/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtenteRemovePermissionDTO
 */
export interface UtenteRemovePermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof UtenteRemovePermissionDTO
     */
    permissionId?: string | null;
}

/**
 * Check if a given object implements the UtenteRemovePermissionDTO interface.
 */
export function instanceOfUtenteRemovePermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UtenteRemovePermissionDTOFromJSON(json: any): UtenteRemovePermissionDTO {
    return UtenteRemovePermissionDTOFromJSONTyped(json, false);
}

export function UtenteRemovePermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtenteRemovePermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissionId': !exists(json, 'permissionId') ? undefined : json['permissionId'],
    };
}

export function UtenteRemovePermissionDTOToJSON(value?: UtenteRemovePermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissionId': value.permissionId,
    };
}

